import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'gen-dropdown-input',
  templateUrl: './dropdown-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class DropdownInputComponent implements OnInit {
  public toggleSelection: boolean = false;
  public enableSelectAllHeader: boolean = true;
  public maxSelectedLabels: number = 2;
  @Input() filter;
  selectedValue: any;

  ngOnInit() {
    this.dropdownCheck(this.filter);
  }
  dropdownCheck(filter) {
    this.selectedValue = filter.tooltip;
  }
}
